module.exports = {
          srcSet: __webpack_public_path__ + "edb070e3eeee019fea63168c3d919772-10.png"+" 10w",
          images:[ {path: __webpack_public_path__ + "edb070e3eeee019fea63168c3d919772-10.png",width: 10,height: 16}],
          src: __webpack_public_path__ + "edb070e3eeee019fea63168c3d919772-10.png",
          toString:function(){return __webpack_public_path__ + "edb070e3eeee019fea63168c3d919772-10.png"},
          
          width: 10,
          height: 16
        }